const EN_PREFIX = '/en';
const SPANISH_ONLY = ['/terminos-y-condiciones', '/politica-de-privacidad', '/envios-y-entregas', '/preguntas-frecuentes', '/cambios-y-devoluciones', '/libro-de-reclamaciones'];

export function isSpanishOnlyPath(pathname) {
  const cleanPath = stripLocale(pathname).replace(/\/$/, '') || '/';
  return SPANISH_ONLY.includes(cleanPath);
}

export function isEnglishPath(pathname) {
  return pathname === EN_PREFIX || pathname.startsWith(`${EN_PREFIX}/`);
}

export function stripLocale(pathname) {
  if (!isEnglishPath(pathname)) return pathname || '/';
  return pathname.slice(EN_PREFIX.length) || '/';
}

export function localizedPath(path, language = 'es') {
  if (!path || !path.startsWith('/') || path.startsWith('//')) return path;
  const url = new URL(path, 'https://miskipop.com');
  const cleanPath = stripLocale(url.pathname);
  const spanishOnly = isSpanishOnlyPath(cleanPath);
  const privatePath = /^\/(admin|influencer)(\/|$)/.test(cleanPath);
  const pathname = language === 'en' && !spanishOnly && !privatePath
    ? `${EN_PREFIX}${cleanPath === '/' ? '/' : cleanPath}`
    : cleanPath;
  return `${pathname}${url.search}${url.hash}`;
}

export function languageFromPath(pathname) {
  return isEnglishPath(pathname) ? 'en' : 'es';
}
